import { NgxPageSize } from './ngxGrid/ngxPageSize.component';
import { NgxRefresh } from './ngxGrid/ngxRefresh.component';
import { NgxToggleColumn } from './ngxGrid/ngxToggleColumn.component';
import { PrintPage } from './print/print.page';
import { PrintPreview } from './print/print.preview';

export const SHARED_COMPONENTS: any[] = [
	NgxPageSize,
	NgxRefresh,
	NgxToggleColumn,
	PrintPage,
	PrintPreview
];

export * from './ngxGrid/ngxPageSize.component';
export * from './ngxGrid/ngxRefresh.component';
export * from './ngxGrid/ngxToggleColumn.component';
export * from './print/print.page';
export * from './print/print.preview';


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/shared/index.ts